import React, { useEffect, useState } from 'react'
import { Button, Modal } from 'antd'

export const ViewProfileModal = ({ data }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const showModal = () => {
    setIsModalOpen(true)
  }
  const handleOk = async () => {
    setIsModalOpen(false)
  }
  const handleCancel = () => {
    setIsModalOpen(false)
  }

  useEffect(() => {}, [])

  return (
    <>
      <Button type='primary' onClick={showModal}>
        View Owner
      </Button>
      <Modal
        title={'Owner'}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <p style={{ paddingBottom: 5 }}>
          Name: {data?.first_name} {data?.name}
        </p>
        <p style={{ paddingBottom: 5 }}>Email: {data?.email}</p>
        <p style={{ paddingBottom: 5 }}>Phone: {data?.phone}</p>
        <p style={{ paddingBottom: 5 }}>Status: {data?.status}</p>
        <p style={{ paddingBottom: 5 }}>
          Active products: {data?.count_active_products}
        </p>
      </Modal>
    </>
  )
}
